module.exports = {
  CALLCENTER_AUTHENTICATION_ERROR: 'callcenter-authentication-error',
  CALLCENTER_ACCESS_DENIED_ERROR: 'callcenter-access-denied-error'
};



// WEBPACK FOOTER //
// ./src/const/ErrorsCodes.js